import { Currency } from "hakikat/utils";

export interface BankAccount {
  bank: string;
  recipient: string;
  currency: Currency;
  swift: string;
  iban: string;
};